function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   position: fixed;\n   width: 100%;\n   box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.3);\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   user-select: none;\n   height: ", ";\n   background-color: ", ";\n   position: relative;\n   z-index: 1000;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
var Header = styled.header(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.sizes.siteHeaderHeight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.brandColors.blue;
});
var FixedHeader = styled(Header)(_templateObject2());

var SiteHeaderShell = function SiteHeaderShell(_ref3) {
  var fixed = _ref3.fixed,
      props = _objectWithoutProperties(_ref3, ["fixed"]);

  return fixed ? /*#__PURE__*/React.createElement(FixedHeader, props) : /*#__PURE__*/React.createElement(Header, props);
};

SiteHeaderShell.defaultProps = {
  fixed: false
};
export { SiteHeaderShell };